import { useState } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Generico } from './Generico';
import { MonitoreoService } from '../service/monitoreo/MonitoreoService';
import { useForm } from 'react-hook-form';
import { useToken } from './useToken';

export const ExportarExcel = ({ title = 'Reporte_Por_Rango', url, diasMaxDescargaReporte }) => {
    const generic = Generico();
    const monitoreoService = new MonitoreoService();
    const { setError } = useForm();
    const { getRol } = useToken();
    const [loading, setLoading] = useState(false);
    const [dialogFechaReporte, setDialogFechaReporte] = useState(false);
    const [fechaInicioSeleccionada, setFechaInicioSeleccionada] = useState(null);
    const [fechaFinSeleccionada, setFechaFinSeleccionada] = useState(null);
    const { fechasDiferenciaEnDias } = Generico();
    const toast = useRef(null);

    const exportar = () => {
        setLoading(true);
        const params = { rol: getRol(), fecha_inicio: fechaInicioSeleccionada, fecha_fin: fechaFinSeleccionada };
        // Para la matriz de cliente y proveedor, el tipo se define en la url
        monitoreoService.generarDocumento(url, params).then(res => {
            generic.downloadPdf(res.data, `${title}.xlsx`);
            setDialogFechaReporte(false);
            setFechaInicioSeleccionada(null);
            setFechaFinSeleccionada(null);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoading(false);
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!fechaInicioSeleccionada || !fechaFinSeleccionada) {
            toast.current.show({ severity: 'warn', summary: 'Faltan fechas', detail: 'Seleccione fecha inicio y fin', });
            return;
        }
        if (fechaInicioSeleccionada > fechaFinSeleccionada) {
            toast.current.show({ severity: 'warn', summary: 'Fechas inválidas', detail: 'La fecha de inicio debe ser menor o igual a la fecha fin', });
            return;
        }
        // Generico para calcular la diferencia en días
        const diffDays = fechasDiferenciaEnDias(fechaInicioSeleccionada, fechaFinSeleccionada);
        if (diffDays > diasMaxDescargaReporte) {
            toast.current.show({ severity: 'warn', summary: 'Rango inválido', detail: `El rango máximo permitido es de ${diasMaxDescargaReporte} días`, });
            return;
        }
        exportar();
    };

    return (
        <div className="p-d-flex p-ai-center">
            <Toast ref={toast} />
            <Button type="button" icon="pi pi-file-export" className="p-button-success mr-2" onClick={() => { setDialogFechaReporte(true); }} disabled={loading} tooltip="Exportar por rango (Excel)" tooltipOptions={{ position: 'left' }} />

            <Dialog visible={dialogFechaReporte} header="Seleccionar rango de fechas para el reporte" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogFechaReporte(false)} style={{ maxWidth: '500px' }}         >
                <form onSubmit={handleSubmit}>
                    <div className="formgrid grid">
                        <div className="field col-6">
                            <label>Fecha Inicio *</label>
                            <Calendar value={fechaInicioSeleccionada} onChange={(e) => setFechaInicioSeleccionada(e.value)} dateFormat="yy-mm-dd" showIcon maxDate={new Date()} readOnlyInput />
                        </div>
                        <div className="field col-6">
                            <label>Fecha Fin *</label>
                            <Calendar value={fechaFinSeleccionada} onChange={(e) => setFechaFinSeleccionada(e.value)} dateFormat="yy-mm-dd" showIcon maxDate={new Date()} readOnlyInput />
                        </div>
                    </div>
                    <div className="p-d-flex p-jc-end p-mt-3">
                        <Button label="Aceptar" type="submit" className="p-ml-2" loading={loading} />
                    </div>
                    <span style={{ color: 'red', fontSize: '9px', fontWeight: 'bold', }}>
                        *El rango máximo permitido para exportar es de {diasMaxDescargaReporte} días
                    </span>
                </form>
            </Dialog>
        </div>
    );
};